real.animator = function() {
    'use strict';

    let
        parentElem,
        hideElem,
        showElem,
        beforeCalculateHeight,
        afterCalculateHeight,
        hideReadyFn,
        showReadyFn,
        animDuration = 'fast'
    ;

    return {

        setParentElement : function(elem) {
            parentElem = elem;
            return this;
        },

        setHideElement : function(elem) {
            hideElem = elem;
            return this;
        },

        setShowElement : function(elem) {
            showElem = elem;
            return this;
        },

        setAnimDuration : function(duration) {
            if (
                typeof howspace !== 'undefined' &&
                typeof howspace.animate.isEnabled === 'function' &&
                !howspace.animate.isEnabled()
            ) {
                // Animations are disabled, set animation duration to zero milliseconds.
                duration = 0;
            }
            animDuration = duration;
            return this;
        },

        onHideReady : function(readyFn) {
            hideReadyFn = readyFn;
            return this;
        },

        onShowReady : function(readyFn) {
            showReadyFn = readyFn;
            return this;
        },

        beforeCalculateHeight : function(fn) {
            beforeCalculateHeight = fn;
            return this;
        },

        afterCalculateHeight : function(fn) {
            afterCalculateHeight = fn;
            return this;
        },

        startAnimation : function() {
            const scrollTop = parentElem.scrollTop();

            if (typeof beforeCalculateHeight === 'function') {
                beforeCalculateHeight();
            }

            const isHideElemVisible = hideElem.is(':visible');
            const isShowElemHidden = showElem.is(':hidden');

            if (isHideElemVisible) {
                hideElem.hide();
            }
            if (isShowElemHidden) {
                showElem.show();
            }

            const animHeight = parentElem.outerHeight();

            if (isHideElemVisible) {
                hideElem.show();
            }
            if (isShowElemHidden) {
                showElem.hide();
            }

            if (typeof afterCalculateHeight === 'function') {
                afterCalculateHeight();
            }

            const animProperties = {
                height : animHeight
            };

            parentElem.scrollTop(scrollTop);

            parentElem.velocity('stop').velocity(animProperties, animDuration);

            if (!isHideElemVisible) {
                if (typeof hideReadyFn === 'function') {
                    hideReadyFn();
                }
            }
            if (!isShowElemHidden) {
                if (typeof showReadyFn === 'function') {
                    showReadyFn();
                }
            }

            const hideOptions = {
                duration : animDuration,
                complete : function() {
                    if (typeof hideReadyFn === 'function') {
                        hideReadyFn();
                    }
                    const showOptions = {
                        duration : animDuration,
                        complete : function() {
                            parentElem.css('height', '');
                            parentElem.css('display', '');
                            if (typeof showReadyFn === 'function') {
                                showReadyFn();
                            }
                        }
                    };

                    if (showElem.is('.grid') || showElem.is('.display-grid') || showElem.is('.d-grid')) {
                        showOptions.display = 'grid';
                    } else if (showElem.is('.flex') || showElem.is('.display-flex') || showElem.is('.d-flex')) {
                        showOptions.display = 'flex';
                    }

                    showElem.velocity('stop').velocity('fadeIn', showOptions);
                }
            };

            if (hideElem.is('.grid') || hideElem.is('.display-grid') || hideElem.is('.d-grid')) {
                hideOptions.display = 'grid';
            } else if (hideElem.is('.flex') || hideElem.is('.display-flex') || hideElem.is('.d-flex')) {
                hideOptions.display = 'flex';
            }

            hideElem.velocity('stop').velocity('fadeOut', hideOptions);
        }

    };

};
